export type Rt50SlabThicknessOption = {
  label: string,
  value: string,
  thicknessCm: number,
  ratioKgM3: number,
};

/** Poids en tonnes : (surface m² × épaisseur m × ratio kg/m³) / 1000 */
const computeRt50Tonnage = (
  surfaceM2: number | null | undefined,
  slabThickness: string | null | undefined,
  options: Rt50SlabThicknessOption[] = [],
): number | null => {
  const surface = Number(surfaceM2);
  if (!Number.isFinite(surface) || surface <= 0) return null;

  const option = options.find((entry) => entry.value === slabThickness);
  if (!option) return null;

  const thicknessM = option.thicknessCm / 100;
  const weightKg = surface * thicknessM * option.ratioKgM3;
  const weightTonnes = weightKg / 1000;

  return Math.round(weightTonnes * 100) / 100;
};

export default computeRt50Tonnage;
